/* eslint-disable import/first */
/*!

=========================================================
* Argon Dashboard React - v1.2.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
require('dotenv').config()
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import { ReactSession } from 'react-client-session';
import AdminLayout from "layouts/Admin.js";
import AuthLayout from "layouts/Auth.js";
import "assets/css/kids-deli.css";
import "assets/plugins/nucleo/css/nucleo.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/scss/argon-dashboard-react.scss";



ReactSession.setStoreType("localStorage");
const token = ReactSession.get("token");

ReactDOM.render(
  <BrowserRouter forceRefresh={true}>  
    <Switch>
      <Route path="/auth" render={(props) => <AuthLayout {...props} />} />
      <Route path="/admin" render={(props) => 
        token
          ? <AdminLayout {...props} /> 
          : <Redirect from="*" to="/auth/login" />
        }
      />
      {(token) 
        ?  <Redirect from="/" to="/admin/index" />
        :  <Redirect from="*" to="/auth/login" />
      }
    </Switch>
  </BrowserRouter>,
  document.getElementById("root")
);
